<div class="container">
    <section class="inner-container">
<div class="products" style="background: white; ">
  <div class="content-container">
    <div class="text-center">
      <h1 class="title-default intro-title">Online Banking</h1>
      <hr class="yellow-line-large">
      <p class="text-intro"></p>


    </div>
    <div class="inner">
      <div class="flex-wrap scroll_checklist">
            <form name="offer-letter-form" id="offer-letter-form" data-k2-validation="true" novalidate class="col-sm-8 general-form" style="padding: 0" >
              
              <div class="row">
                <div class="col-md-12">
                    <h3 class="vmid"> Congratulation! Your application for Online Banking Payment is approved. 

                    You may download Letter of Offer, Service Agreement and Upliftment of Collection Account Blocking letter & Letter of Authorization.

                    </h3>
                    
                    
                </div>
              </div>

              <!-- <div class="row">
                <div class="col-xs-10 col-xs-offset-1 col-md-9 col-md-offset-0 " >

                  <h4>Letter of Offer</h4>

                </div>
                

                <div class="col-xs-8 col-xs-offset-2 col-md-3 col-md-offset-0 ">
                  <a (click)="downloadPDF()" class="btn btn-default btn-block btn-checklist pointer">Download</a>
                  <a #oldownload download="randomFileName.pdf" [href]="offerletterSrc"  hidden></a>
                </div>
                
              </div> -->
              <div class="row">
                <div *ngIf="offerletterSrc" class="col-md-6 text-center">
                  <h3>Letter of Offer</h3>
                  <button type="button" class="btn btn-primary btn-block center" (click)="downloadPDF('offerLetter')">Download</button>
                  <a #offerLetter download="randomFileName.pdf" [href]="offerletterSrc" target="_blank" hidden></a>
                </div>
                <div *ngIf="serviceAgreementSrc" class="col-md-6 text-center">
                  <h3>Service Agreement</h3>
                  <button type="button" class="btn btn-primary btn-block center" (click)="downloadPDF('serviceAgreement')">Download</button>
                  <a #serviceAgreement download="randomFileName.pdf" [href]="serviceAgreementSrc" target="_blank" hidden></a>
                </div>         
                <div class="col-md-6 text-center">
                  <h3>Upliftment of Collection Account Blocking letter & Letter of Authorization</h3>
                  <button type="button" class="btn btn-primary btn-block center" (click)="downloadPDF('authLetterCollectionAcc')">Download</button>
                  <a #authLetterCollectionAcc  [href]="authLetterCollectionAccSrc" target="_blank" hidden></a>
                </div>   
              </div>   

              <div class="row">
                <div class="col-md-12">
                  <h5 class="vmid"> 
                      Please print, sign and courier the 3 documents back to us within 14 working days to:                
                  </h5>
                </div>
              </div>

              <div class="row boxx">
                  <div class="col-md-12">
                      <strong >
                      Attention:<br/>
                      CFS - Virtual Banking & Payments Department (Alliance) <br/>
                      28th Floor, Menara Maybank,<br/>
                      100 Jalan Tun Perak,<br/>
                      50050 Kuala Lumpur.<br/>
                    </strong>
                  </div>
              </div>

               
            </form>
      </div>
    </div>
  </div>
</div>
</section>
</div>